import React, { Component } from 'react';
import {
	Question, Shoutbox, TotalPlayers, QuizToWin, NextStream,
} from '../sections';
import QuizResults from './children/results';

class Quiz extends Component {
	renderQuestionOrQuizResults() {
		const { winners, activeQuestion } = this.props;
		if (winners) {
			return (<QuizResults />);
		}
		return (<Question question={activeQuestion} onTimerDone={this.props.questionDone} />);
	}

	render() {
		const {
			doneQuestion,
		} = this.props;
		return (
			<div className="d-flex flex-column h-100">
				<div className="flex-grow-1 row">
					<div className="col bd-highlight-right">
						<Question question={doneQuestion} />
					</div>
					<div className="col-5 bd-highlight-right">
						{this.renderQuestionOrQuizResults()}
					</div>
					<div className="col bd-highlight-right">
						<Shoutbox />
					</div>
				</div>
				<div className="d-flex row">
					<div className="col bd-highlight-right bd-highlight-top">
						<TotalPlayers />
					</div>
					<div className="col-5 bd-highlight-right bd-highlight-top">
						<QuizToWin />
					</div>
					<div className="col bd-highlight-right bd-highlight-top">
						<NextStream />
					</div>
				</div>
			</div>
		);
	}
}

Quiz.defaultProps = {};

export default Quiz;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/Quiz.component.js